import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import SideBarMenu from '@client/containers/sideBarMenu/SideBarMenu';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import {
  loadProfilePageData,
  selectProfilePageData,
} from '@client/pages/profilePage/duckProfilePage';
import { valueOrEmptyStr } from '@client/shared/utils/utils/utils';
import Markdown from '@client/components/markdown/Markdown';
import styles from './helpPage.scss';

class HelpPage extends PureComponent {
  constructor(props) {
    super(props);
  }
  static loadData(dispatch) {
    return dispatch(loadProfilePageData());
  }

  componentDidMount() {
    if (!this.props.pageData || this.props.pageData.size === 0) {
      HelpPage.loadData(this.props.dispatch);
    }
  }

  render() {
    const { location, pageData } = this.props;
    const helpPageTitle = getIn(pageData, 'helpTitle');
    const helpPageText = getIn(pageData, 'helpText');

    return (
      <div className={`${styles.helpPage} ${styleHelper.contentContainer}`}>
        <div className={styles.asideContainer}>
          <SideBarMenu pathname={location.pathname} />
        </div>
        <div className={styles.mainContainer}>
          <h3
            className={`${styleHelper.titleMdPrimary} ${styleHelper._title} ${styles.title}`}
          >
            {helpPageTitle}
          </h3>
          {
            <Markdown
              className={`${styleHelper.layoutMobileSidePadding} ${styles.markdownProp}`}
              value={valueOrEmptyStr(helpPageText)}
              viewAsTextarea={false}
            />
          }
        </div>
      </div>
    );
  }
}

HelpPage.propTypes = {
  location: PropTypes.object,
  translations: ImmutablePropTypes.map,
  pageData: ImmutablePropTypes.map,
  dispatch: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    pageData: selectProfilePageData(state),
  };
}

export default connect(mapStateToProps)(HelpPage);
